export default class Amount {
    static calculateTotalAmount(state) {
        let totalPrice = parseFloat(state.product.amount);
        totalPrice = state.users.filter(user => user.numberOfUsers > user.minNumberOfUsers && user.numberOfUsers > user.numberOfFreeUsers)
            .reduce((accumulatedAmount,  user) => accumulatedAmount + (parseFloat(user.amountPerUser) * (user.numberOfUsers - user.numberOfFreeUsers)), totalPrice);
        totalPrice = state.modules.filter(modules => modules.active)
            .reduce((accumulatedAmount,  modules) => accumulatedAmount + parseFloat(modules.amount), totalPrice);

        // Calculate bundles
        totalPrice = state.modules.filter(modules => modules.bundleQuantity && modules.bundlePrice && modules.active)
            .reduce((accumulatedAmount,  modules) => accumulatedAmount +
                (
                    Number(modules.numberOfItems) * parseFloat(modules.bundlePrice)
                ), totalPrice);

        for(const u of state.users) { // eslint disable no-loop-func
            if (u.chosenProvider && u.chosenProvider[0] && u.chosenProvider[0].amount > 0) {
                totalPrice += Number(u.numberOfUsers) * parseFloat(u.chosenProvider[0].amount);
            }
        }

        return totalPrice;
    }

    static calculateTotalAmountIncludingExtras(state) {
        let totalPrice = parseFloat(state.product.amount);
        totalPrice = state.users.filter(user => user.numberOfUsers > 1 && user.numberOfUsers > user.numberOfFreeUsers)
            .reduce((accumulatedAmount,  user) => accumulatedAmount + (parseFloat(user.amountPerUser) * (user.numberOfUsers - user.numberOfFreeUsers)), totalPrice);
        totalPrice = state.modules.filter(modules => modules.active)
            .reduce((accumulatedAmount,  modules) => accumulatedAmount + parseFloat(modules.amount), totalPrice);
        totalPrice = state.extras.filter(extra => extra.active)
            .reduce((accumulatedAmount,  extra) => accumulatedAmount + parseFloat(extra.amount), totalPrice);

        // Calculate bundles
        totalPrice = state.modules.filter(modules => modules.active).filter(modules => modules.bundleQuantity && modules.bundlePrice)
            .reduce((accumulatedAmount,  modules) => accumulatedAmount +
                    (
                        Number(modules.bundleQuantity) * parseFloat(modules.bundlePrice) +
                        (Number(modules.numberOfItems) - Number(modules.bundleQuantity)) * parseFloat(modules.nonBundlePrice)
                    ), totalPrice);

        return totalPrice;
    }
}
